import PhoneInput from "./phone-input.svelte"
import CountrySelector from "./country-selector.svelte"
import Flag from "./flag.svelte"
import type {
  Country,
  CountryCode,
  DetailedValue,
  E164Number,
  TelInputOptions,
} from "svelte-tel-input/types"

export type Props = {
  country?: CountryCode | null
  defaultCountry?: CountryCode | null
  el?: HTMLInputElement
  name?: string
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  class?: string
  value: E164Number | null
  valid?: boolean
  detailedValue?: Partial<DetailedValue> | null
  options?: TelInputOptions
  order?: ((a: Country, b: Country) => number) | undefined
}

export const defaultOptions = {
  defaultCountry: "US",
  placeholder: "Enter phone number",
  preferredCountries: [
    "US",
    "GB",
    "MX",
    "CA",
    "AU",
    "NZ",
    "CN",
    "HK",
    "IN",
    "ZA",
    "ID",
    "KR",
    "IT",
    "VN",
    "SE",
    "FI",
    "FR",
    "DE",
    "IT",
    "ES",
    "VN",
    "PT",
    "NL",
    "RU",
    "PK",
  ],
  regions: [],
}

function getCountryName(code: string): string {
  const countries = new Intl.DisplayNames(["en"], { type: "region" })
  try {
    // Convert code to uppercase to ensure proper format
    const countryName = countries.of(code.toUpperCase())
    return countryName || code
  } catch (error) {
    // Return the original code if conversion fails
    return code
  }
}

export { PhoneInput, CountrySelector, Flag, getCountryName }
